import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=2ee8d1d2&"
import script from "./CommonFooter.vue?vue&type=script&lang=ts&"
export * from "./CommonFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports